import { render } from "./ic-plus.vue?vue&type=template&id=4e71e094&ts=true"
import script from "./ic-plus.vue?vue&type=script&lang=ts"
export * from "./ic-plus.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__